import { Checkbox } from '@nextui-org/react';
import type { UserPermission } from '../../utils/user-permissions';

/** Permisos de un usuario basic: un checkbox por ítem del menú. */
export default function BasicPermissionsPicker({
  available,
  selected,
  onChange,
}: {
  available: UserPermission[];
  selected: string[];
  onChange: (keys: string[]) => void;
}) {
  const toggle = (key: string) =>
    onChange(selected.includes(key) ? selected.filter((k) => k !== key) : [...selected, key]);
  return (
    <div className='flex flex-col gap-2'>
      <p className='text-sm text-default-500'>Permisos del usuario basic</p>
      <div className='grid grid-cols-1 gap-2 md:grid-cols-2'>
        {available.map((p) => (
          <Checkbox
            key={p.sidebarItemKey}
            size='sm'
            isSelected={selected.includes(p.sidebarItemKey)}
            onValueChange={() => toggle(p.sidebarItemKey)}
          >
            {p.title}
          </Checkbox>
        ))}
      </div>
    </div>
  );
}
